export default {
  pages: {
    key: "title",
    data: [
     /* {title: "Trendyol",url: "/pazaryeri/trendyolsipariscek",icon: "CheckSquareIcon",is_bookmarked: true},
      {title: "N11",url: "/pazaryeri/n11sipariscek",icon: "CheckSquareIcon",is_bookmarked: true},
      {title: "Morhipo",url: "/pazaryeri/morhiposipariscek",icon: "CheckSquareIcon",is_bookmarked: true},
      {title: "Paketleme",     url: "/paketleme/paketlemeislemi",                icon: "GitPullRequestIcon",     is_bookmarked: true},*/
    ]
  }
}
